/**
 * Helpers para filtrado de recogidas en cliente
 */
import { formatearDireccion } from './direccion';

/**
 * Aplica filtros de búsqueda del lado del cliente
 * @param {Array} recogidas - Lista de recogidas
 * @param {Object} filtros - Filtros a aplicar
 * @param {string} filtros.q - Búsqueda por texto
 * @returns {Array} Recogidas filtradas
 */
export const aplicarFiltrosCliente = (recogidas, filtros) => {
    let resultado = [...recogidas];

    // Filtro por búsqueda de texto
    if (filtros.q && filtros.q.trim()) {
        const q = filtros.q.toLowerCase().trim();
        resultado = resultado.filter(r =>
            r.numeroTicket?.toLowerCase().includes(q) ||
            r.clienteNombre?.toLowerCase().includes(q) ||
            formatearDireccion(r.direccion).toLowerCase().includes(q)
        );
    }

    return resultado;
};
